import { render, staticRenderFns } from "./poetry-share.vue?vue&type=template&id=3e31328e&scoped=true&"
import script from "./poetry-share.vue?vue&type=script&lang=js&"
export * from "./poetry-share.vue?vue&type=script&lang=js&"
import style0 from "./poetry-share.vue?vue&type=style&index=0&id=3e31328e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e31328e",
  null
  
)

export default component.exports